import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import Button, { icons } from 'components/Button'
import Lesson from 'components/Lessons/Lesson.js'

// import Info from 'components/Info'
function compare(a, b) {
  if (a.weight < b.weight) {
    return -1;
  }
  if (a.weight > b.weight) {
    return 1;
  }
  return 0;
}
const Lessons = ({
  lessons = [],
  children = null,
  onChange,
  toggleLesson,
  addPriceGroup,
  addCustomLesson,
  removePriceGroup,
}) => (
  <div className="fieldset-wrap" id="lessons">
    <fieldset className="fieldset">
      <legend className="legend">
        <div className="form-group form-group__legend form-group__with-info info__pin-right">
          3. Private lessons<br />
          <small>Choose the private services you offer and fill in the descriptions.</small>
          {/*
            <Info className="info__pin-right">
            The default working hours can be changed later.
            You can also easily block times from your calendar, so it's better to have more than less open times.
            </Info>
          */}
        </div>
      </legend>
      {
        lessons.sort(compare).map((lesson, index) => (
          <Lesson
            index={index}
            key={`lesson-${index}`}
            toggleLesson={toggleLesson}
            addPriceGroup={addPriceGroup}
            onChange={onChange}
            removePriceGroup={removePriceGroup}
            {...lesson}
          />
        ))
      }
      <Row className="form--row form--row__add-lesson">
        <Col xs={12}>
          <Button
            type="button"
            icon={icons.PLUS}
            prependIcon
            buttonType="ghost"
            onClick={addCustomLesson}
          >
          Add new lesson type
          </Button>
        </Col>
      </Row>
      { children }
    </fieldset>
  </div>
)

export default Lessons



// WEBPACK FOOTER //
// ./src/components/Lessons/Lessons.js